module.exports = __webpack_public_path__ + "img/valleint1.cfaa2f52.png";